export default __webpack_public_path__ + "static/media/payment_loading.2ab47fd0.svg";